module.exports = __webpack_public_path__ + "media/white_logo/neva-3a792b6c.png";